import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/rootState';

function ComponentTotalExpenseTable() {
  const { themePdfColor, reportPdfResponse4 } = useSelector((state: RootState) => state.reportPdfSliceReducer);
  const { BorderColor, MainColor } = themePdfColor;
  const total = useMemo(() => {
    const cash = reportPdfResponse4?.Expense_Report?.map((item) => item?.TotalCash?.TotalCash || 0).reduce((sum, val) => sum + val, 0);
    const cheque = reportPdfResponse4?.Expense_Report?.map((item) => item?.TotalCheque?.TotalCheque || 0).reduce((sum, val) => sum + val, 0);
    const both = cash + cheque;
    return { cash, cheque, both };
  }, [reportPdfResponse4]);
  return (
    <div style={{ marginTop: '20px' }}>
      <div className="underlineHeadingText textCenter">Combined Total Expenses for All Reports</div>
      <table className="bordered-table w100">
        <div
          className="tableAfterThickBorderStyle"
          style={{
            backgroundColor: BorderColor,
          }}
        />
        <div
          className="tableBeforeThickBorderStyle"
          style={{
            backgroundColor: BorderColor,
          }}
        />
        <tr>
          <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
            Total Cash Due
          </td>
          <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
            Total Charges
          </td>
          <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: MainColor }}>
            Total Expenses
          </td>
        </tr>
        <tr>
          <td className="textCenter">{total?.cash}</td>
          <td className="textCenter">{total?.cheque}</td>
          <td className="textCenter">{total?.both}</td>
        </tr>
      </table>
    </div>
  );
}

export default ComponentTotalExpenseTable;
